import { Controller } from './Controller';
import { Loader } from './Loader';
import { Store } from './Store';
import { Ticker } from './Ticker';

export function createCoreModules(app) {
  const loader = new Loader(app);
  const ticker = new Ticker(app);
  const store = new Store(app);
  const controller = new Controller(app);

  return {
    loader,
    ticker,
    store,
    controller,
  };
}
